import { render, staticRenderFns } from "./BandomProduct.vue?vue&type=template&id=8c02271c&scoped=true&"
import script from "./BandomProduct.vue?vue&type=script&lang=js&"
export * from "./BandomProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c02271c",
  null
  
)

export default component.exports